<template>
    <!-- <AppLayout title="Lista de categorías" :options="options"> -->
    <AppLayout>
        <div v-if="$page.props.auth.roles[0] !== 'admin'">
            <div class="container-fluid">
                <div class="row p-19">
                    <div class="col-md-12">
                        <div class="row">

                            <div class="col-md-4">
                            </div>
                            <div class="col-md-4">
                                <div class="jumbotron">
                                    <h1 class="text-center text-danger">
                                        Atención!!!
                                    </h1>
                                    <br>

                                    <h3 class="text-center">
                                        Acceso denegado
                                    </h3>
                                    <p class="text-center">
                                        No tiene permisos para acceder
                                    </p>
                                    <br>
                                    <br>
                                    <br>
                                    <br>
                                    <br>
                                    <br>
                                    <br>
                                    <br>


                                </div>
                            </div>
                            <div class="col-md-4">
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div v-if="$page.props.auth.roles[0] === 'admin'">
            <div class="card">
                <div class="card-body py-3">
                    <div class="card-header border-0 pt-5">
                        <h3 class="card-title align-items-start flex-column">
                            <span class="card-label fw-bold fs-3 mb-1">Copias de Seguridad</span>
                        </h3>

                        <div class="card-toolbar" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-trigger="hover"
                            title="Click para registrar una nueva copia">
                            <Link :href="route('backups.create')" class="btn btn-sm btn-light-primary">
                            <span class="svg-icon svg-icon-3">
                                <inline-svg src="/images/icons/duotune/arrows/arr075.svg" />
                            </span>
                            Nueva Copia de Seguridad
                            </Link>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                            <thead>
                                <tr class="fw-bold text-muted">
                                    <th class="min-w-150px">Nombre</th>
                                    <th class="min-w-100px text-end">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="backup in backups" :key="backup.file_name">
                                    <tr>
                                        <td>{{ backup.file_name }}</td>
                                        <td class="text-end">

                                            <button @click.prevent="downloadFile(backup.file_name)"
                                                class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                                                <span class="svg-icon svg-icon-3">
                                                    <inline-svg src="/images/icons/duotune/art/art005.svg" />
                                                </span>
                                            </button>

                                            <Link :href="route('backups.destroy', backup.file_name)" method="delete"
                                                as="button"
                                                class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                                            <span class="svg-icon svg-icon-3">
                                                <inline-svg src="/images/icons/duotune/general/gen027.svg" />
                                            </span>
                                            </Link>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script setup>
import AppLayout from "@/Layouts/AppLayout";
import axios from "axios";

defineProps({
    backups: Array,
})

const downloadFile = (filename) => {

    fetch(route('backups.download', filename), {
        method: 'GET'
    }).then(response => response.blob())
        .then(blob => {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = "backup.zip";
            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
            a.click();
            a.remove();  //afterwards we remove the element again
        })
}
</script>
